import '../dashboard.css';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';

export default function Dashboard() {
  const location = useLocation();
  const year = new Date().getFullYear();

  const [proyectosActivos, setProyectosActivos] = useState(0);
  const [cotizacionesTotal, setCotizacionesTotal] = useState(0);
  const [proyectosFinalizados, setProyectosFinalizados] = useState(0);

  useEffect(() => {
    cargarEstadisticas();
  }, []);

  const cargarEstadisticas = async () => {
    try {
      const resProyectos = await axios.get(
        'https://api-rci-g5ebbhava3anbgfy.centralus-01.azurewebsites.net/api/Proyectos'
      );

      const resCotizaciones = await axios.get(
        'https://api-rci-g5ebbhava3anbgfy.centralus-01.azurewebsites.net/api/Cotizaciones'
      );

      const proyectos = resProyectos.data || [];
      const cotizaciones = resCotizaciones.data || [];

      const activos = proyectos.filter(p => {
        const estatus = (p.estatus ?? p.Estatus ?? '').toLowerCase();
        return estatus === 'en progreso';
      }).length;

      const finalizados = proyectos.filter(p => {
        const estatus = (p.estatus ?? p.Estatus ?? '').toLowerCase();
        return estatus === 'finalizado';
      }).length;

      setProyectosActivos(activos);
      setCotizacionesTotal(cotizaciones.length);
      setProyectosFinalizados(finalizados);

    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  };

  return (
    <div className="dashboard-layout page-dashboard">
      <aside className="sidebar">
        <div className="sidebar-title">RCI</div>

        <nav>
          <Link
            to="/dashboard"
            className={location.pathname === '/dashboard' ? 'active' : ''}
          >
            Inicio
          </Link>

          <Link
            to="/cotizaciones"
            className={location.pathname.startsWith('/cotizaciones') ? 'active' : ''}
          >
            Cotizaciones
          </Link>

          <Link
            to="/generadores"
            className={location.pathname.startsWith('/generadores') ? 'active' : ''}
          >
            Generadores
          </Link>

          <Link
            to="/proyectos"
            className={location.pathname.startsWith('/proyectos') ? 'active' : ''}
          >
            Proyectos
          </Link>

          <Link
            to="/clientes"
            className={location.pathname.startsWith('/clientes') ? 'active' : ''}
          >
            Clientes
          </Link>
        </nav>
      </aside>

      <div className="main-area">
        <header className="header">
          <h1>Administrador de Proyectos</h1>
        </header>

        <main className="content">
          <h2>Bienvenido</h2>
          <p>Seleccione un módulo en el menú lateral para comenzar.</p>

          <div className="dashboard-body">
            <div className="rci-image" />

            <div className="stats">
              <div className="card">
                <div className="count">{proyectosActivos}</div>
                <div>Proyectos activos</div>
              </div>

              <div className="card">
                <div className="count">{cotizacionesTotal}</div>
                <div>Cotizaciones generadas</div>
              </div>

              <div className="card">
                <div className="count">{proyectosFinalizados}</div>
                <div>Proyectos finalizados</div>
              </div>
            </div>
          </div>
        </main>

        <footer className="footer">© {year} RCI</footer>
      </div>
    </div>
  );
}